// src/Footer.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import LogoLink from './LogoLink.jsx';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-top">
          <div className="footer-brand">
            <LogoLink className="footer-logo" iconSize={24} />
            <p className="footer-tagline">AI-Powered Stock Analysis & Market Insights</p>
          </div>
          <div className="footer-contact">
            <span>📧</span>
            <a href="mailto:ryan@tickrtrends.com">ryan@tickrtrends.com</a>
          </div>
        </div>

        <div className="footer-links">
          <Link to="/terms">Terms of Service</Link>
          <Link to="/privacy">Privacy Policy</Link>
          <Link to="/refund">Refund Policy</Link>
          <Link to="/contact">Contact Us</Link>
        </div>

        <div className="footer-bottom">
          <p className="footer-copyright">
            © {new Date().getFullYear()} TickrTrends. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;